import { Card, CardContent, CardHeader, CardTitle } from "@/ui/components/ui/card";

interface KPICardProps {
  label: string;
  value: string | number;
  size?: "small" | "medium" | "large";
}

const KPICard = ({ label, value, size = "medium" }: KPICardProps) => {
  const sizeClasses = {
    small: {
      header: "p-2 pb-1",
      title: "text-[10px]",
      content: "p-2 pt-0",
      value: "text-base",
    },
    medium: {
      header: "p-3 pb-2",
      title: "text-xs",
      content: "p-3 pt-0",
      value: "text-2xl",
    },
    large: {
      header: "p-4 pb-2",
      title: "text-sm",
      content: "p-4 pt-0",
      value: "text-3xl",
    },
  };

  const classes = sizeClasses[size];

  return (
    <Card className="bg-background/50 flex flex-col justify-between min-w-0 overflow-hidden">
      <CardHeader className={classes.header}>
        <CardTitle
          className={`${classes.title} text-muted-foreground leading-tight break-words`}
        >
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className={classes.content}>
        <p className={`${classes.value} font-bold truncate`} title={String(value)}>
          {value}
        </p>
      </CardContent>
    </Card>
  );
};

export default KPICard;
